import { z } from "zod";
import { apiBuilder, prefixApi } from "@zodios/core";
import { dataReportStatsSchema as statsSchema } from "zodios/common/statsSchema";

export const categoryReportApiDefinitions = prefixApi(
  "/api/data_report",
  apiBuilder({
    alias: "getCategoryReport",
    method: "get",
    path: "/category_report",
    status: 200,
    parameters: [
      {
        name: "mp",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "channel",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "group_by",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "date_group",
        type: "Query",
        schema: z.string(),
      },
      { name: "empty", type: "Query", schema: z.boolean() },
      {
        name: "start_date",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "end_date",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "pre_start_date",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "pre_end_date",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "category",
        type: "Query",
        schema: z.string().optional(),
      },
    ],
    response: z.object({
      total: statsSchema,
      date: z.array(
        statsSchema.extend({
          start_date: z.string(),
        }),
      ),
      categories: z.array(
        statsSchema.extend({
          category_name: z.string(),
          category_id: z.number(),
        }),
      ),
    }),
  }).build(),
);
